export const TITLE_WELCOME_HOME = 'Welcome home';

export const TITLE_YOU_WON_THE_AUCTION = 'You won the auction!';

/** The BODY that always rides beside {@link TITLE_YOU_WON_THE_AUCTION}. Two producers send this notification -- the
 *  operator-driven `mm-choose-another-winner` and the automatic `property-auction-timer-tick` -- and they already
 *  shared the title while each spelled the body for itself, so half the pair was homed and half could drift. The
 *  winner cannot tell which path awarded them the property, so the two must render identical bytes. `formattedBid` is
 *  the caller's already-formatted amount (or its own no-amount stand-in), because only the caller knows whether it
 *  holds a usable number.
 *
 *  @runtime-derived-ssot-helper: the BODY half of the same-leaf {@link TITLE_YOU_WON_THE_AUCTION} pair, derived at
 *  runtime because only the caller holds the formatted amount. */
export function buildAuctionWonNotificationBody(formattedBid: string): string {
	return `${formattedBid} was the winning bid. Go to Transactions -> Under contract to proceed with the next steps.`;
}

export const TITLE_CREATE_WISHLIST = 'Create wishlist';

/** The detail header's one edit control opens the create form pre-filled under this title. */
export const TITLE_EDIT_WISHLIST = 'Edit wishlist';

export const TITLE_FUNCTION_TITLE = 'Function title';

export const TITLE_FINDINGS = 'Findings';

// AUCTION

export const AUCTION_WON_NO_AMOUNT_BID_COPY = 'Your bid';
